import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { forEach, get, isEmpty, merge, omit, reduce, set, pick, find } from 'lodash';
import { mapFormFields, reduceToValues, updateFormFields, fieldsHasErrors } from '../../../lib/form';
import { validateFormField } from '../../../modelValidator';
import {getSchema as getUserSchema} from '../../../models/user';

import Button from '../../../common/components/Button';
import TextField from '../../../common/components/c_TextField';
import MaskedTextField from '../../../common/components/c_MaskedTextField';
import TextArea from '../../../common/components/c_TextArea';
import DropDownMenu from '../../../common/components/c_DropDownMenu';

import * as contactApi from '../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../redux/actionCreators/sync/contacts';
import { updateUser } from '../../../redux/actionCreators/sync';

import * as syncActions from '../../../redux/actionCreators/sync';
import * as ui from '../../../redux/actionCreators/sync/ui';

export const contactFields = {
  user: {
    required : ['firstName', 'lastName', 'email', 'phoneNumber1', 'phoneType1', 'address', 'city', 'state', 'zip'],
    optional : ['phoneExtension1', 'phoneExtension2', 'phoneNumber2', 'phoneType2', 'address2', 'timezone']
  },
  profile: {
    required : ['title', 'initialInquiry'],
    optional : ['department']
  }
};

function initializeContactForm(contact = {}) {
  const {
    profile = {},
    user = {}
  } = contact;

  return {
    user : merge(mapFormFields(user, contactFields.user.required, contactFields.user.optional), pick(getUserSchema(), ['phoneNumber1', 'phoneNumber2'])),
    profile : mapFormFields(profile, contactFields.profile.required, contactFields.profile.optional),
    company : {}
  };
}

function ContactInfoForm(props) {

  const {
    contact = {},
    stateList = [],
    timezoneList = [],
    phoneTypeList = [],
    contactTypes = [],
    updateContact,
  } = props;

  function handleChange(model, prop) {
    return (event, value) => updateContact(event, model, prop, value);
  }

  function renderFieldProperties(model, prop, label) {
    const field = get(contact, `${model}.${prop}`, {});

    return {
      'data-id': `${model}${prop}`,
      defaultValue: field.defaultValue,
      floatingLabelText: label,
      isDirty: !!(field.required ? get(field, 'errors[0]') : undefined),
      errorText: field.required ? get(field, 'errors[0]') : undefined,
      onBlur: handleChange(model, prop)
    };
  }


  function renderCheckListFieldProperties(model, prop, label, menuItems) {
    const field = get(contact, `${model}.${prop}`, {});

    return {
      'data-id': `${model}${prop}`,
      defaultValue: field.defaultValue,
      floatingLabelText: label,
      isDirty: !!(field.required ? get(field, 'errors[0]') : undefined),
      errorText: field.required ? get(field, 'errors[0]') : undefined,
      onBlur: handleChange(model, prop),
      menuItems
    };
  }

  function renderDropDownFieldProperties(model, prop, label, menuItems) {
    return merge(renderFieldProperties(model, prop, label), { menuItems });
  }

  const mainPhone = find(phoneTypeList, {name: 'Main'});
  const mainPhoneId = get(mainPhone, 'id');

  return (
    <div className='contact-info-form grid'>

      <div className='row'>
        <div className='col'>
          <TextField  {...renderFieldProperties('user', 'firstName', 'First Name')} />
        </div>
        <div className='col'>
           <TextField  {...renderFieldProperties('user', 'lastName', 'Last Name')} />
        </div>
        <div className='col'>
          <TextField {...renderFieldProperties('profile', 'title', 'Title')} />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
            <TextField disabled {...renderFieldProperties('user', 'email', 'Email')} />
         </div>
          <div className='col'>
            <div className='row  phone-number-row'>
              <div className='col grow-2'>
                <MaskedTextField
                  className='phone-number center-column-2'
                  hideMaskChar
                  {...renderDropDownFieldProperties('user', 'phoneNumber1', 'Phone Number')}
                  mask='(999) 999-9999' />
              </div>
              <div className='col'>
                <DropDownMenu className='phone-type-dropdown'
                  {...renderDropDownFieldProperties('user', 'phoneType1', null, phoneTypeList)} />
              </div>

                {  (props.contact.user.phoneType1.value || props.contact.user.phoneType1.defaultValue ) === mainPhoneId &&
                  <div className='col'>
                    <TextField type='number'
                      type='number'
                      min='0'
                      step='1'
                      floatingLabelFixed
                      {...renderFieldProperties('user', 'phoneExtension1', 'Extension')} />
                  </div>
                }

            </div>
          </div>

      <div className='col'>
          <div className='row phone-number-row'>
            <div className='col grow-2'>
              <MaskedTextField className='phone-number center-column-2'
                hideMaskChar
                validation={getUserSchema().phoneNumber2}
                {...renderDropDownFieldProperties('user', 'phoneNumber2', 'Phone Number')}
                mask='(999) 999-9999'/>

            </div>
            <div className='col'>
                <DropDownMenu className='phone-type-dropdown'
                  {...renderDropDownFieldProperties('user', 'phoneType2', null, phoneTypeList)}/>

            </div>

            { (props.contact.user.phoneType2.value || props.contact.user.phoneType2.defaultValue) === mainPhoneId
            &&
              <div className='col'>
                <TextField type='number' step='1' min='0' floatingLabelFixed={true} {...renderFieldProperties('user', 'phoneExtension2', 'Extension')} />
              </div>
            }

          </div>
      </div>
      </div>
      <div className='row'>
        <div className='col'>
          <TextField {...renderFieldProperties('user', 'address', 'Address Line 1')} />
        </div>
        <div className='col'>
          <TextField {...renderFieldProperties('user', 'address2', 'Address Line 2')} />
        </div>
        <div className='col'>
          <DropDownMenu {...renderDropDownFieldProperties('user', 'timezone', 'Timezone', timezoneList)} />
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <TextField  {...renderFieldProperties('user', 'city', 'City')} />
        </div>
         <div className='col'>
            <DropDownMenu  {...renderDropDownFieldProperties('user', 'state', 'State', stateList)} />
         </div>
         <div className='col'>
            <TextField type="number" maxLength="5" {...renderFieldProperties('user', 'zip', 'Zip')} />
         </div>
      </div>
      <div className='row'>
        <div className='col'>
          <TextField {...renderFieldProperties('profile', 'department', 'Department')} />
        </div>
        <div className='col'>
        </div>

        <div className='col'></div>

      </div>
      <div className='row' style={{marginTop: '20px'}}>
        <div className='col'>
          <TextArea description='Inquiry Reason' {...renderFieldProperties('profile', 'initialInquiry', 'Inquiry Reason')} />
        </div>
      </div>
    </div>
  );
}

ContactInfoForm.propTypes = {
  contact : PropTypes.object.isRequired,
  stateList : PropTypes.array.isRequired,
  timezoneList : PropTypes.array.isRequired,
  phoneTypeList : PropTypes.array.isRequired,
  contactTypes : PropTypes.array.isRequired,
  updateContact : PropTypes.func.isRequired
};

@connect((state) => ({
  contact: state.contactProfile,
  staticData: state.staticData
}))
export default class ClientContactInfo extends React.Component {

  static propTypes = {
    dispatch : PropTypes.func.isRequired,
    contact : PropTypes.object.isRequired,
    staticData: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);

    const contactForm = initializeContactForm(props.contact);

    this.state = {
      contactForm,
      showErrors: false,
      showForm: !isEmpty(props.contact) // use this so we don't load the form with empty contact data on initial load
    };

    if(this.state.showForm) {
      this.validateContactForm(this.state.contactForm);
    }

  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyPress);
    this.props.dispatch(syncActions.setNavState({isOpen: true, hideClose: true}));
    const contact = this.props.contact;
    if (!get(contact, 'profile.verified', true)) {
      this.setVerified(contact);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.contact) {
      const contactForm = initializeContactForm(nextProps.contact);
      const contact = nextProps.contact;

      if (!get(contact, 'profile.verified', true)) {
        this.setVerified(contact);
      }

      this.validateContactForm(contactForm);

      this.setState(merge({...this.state}, {contactForm, showErrors: false, showForm: true}));
    }
  }

  setVerified(contact) {

    const updatedContact = {
      user: {
        id: contact.user.id,
      },
      profile : {
        id: contact.profile.id,
        verified: true
      },
      company : {
        id: contact.company.id
      }
    };

    this.props.dispatch(contactApi.updateContact(updatedContact, (err, result) => {
      if (err || !result) {
        return console.error(err || 'Update failed.');
      }

      this.props.dispatch(contactStore.updateProfile(result.contact.profile));
    }));
  }

  goToDashboard() {
    this.props.dispatch(push('/client'));
  }

  hasErrors(contactForm) {
    return reduce(contactForm, (errors, model) =>
      fieldsHasErrors(model) || errors,
      false
    );
  }

  validateContactForm(form) {
    forEach(form, (model, key) => this.validateForm(model, contactFields[key]));
    this.validatePhoneNumber(form);
  }

  validateForm(form, fields) {
    if (fields !== undefined) {
      forEach(form, (prop, key) => {
        if (fields.required.includes(key)) {
          set(form, `${key}.errors`,  validateFormField(key, form));
        }
      });
    }
  }

  validatePhoneNumber(form) {
    const pattern = new RegExp(/^[2-9]\d{9}$/);
    const phoneNumber = get(form, 'phoneNumber1.value');
    if (phoneNumber!=='') {
      if (pattern.test(phoneNumber)===false) {
        set(form, 'phoneNumber1.errors', ['Must be a valid phone number.']);
      }
    }
  }

  handleKeyPress = (event) => {
    // escape key response
    if(event.keyCode === 27) {
      this.goToDashboard();
    }
  }

  updateFormFields(model, prop, newValue) {
    set(model, `${prop}.value`, newValue);
    set(model, `${prop}.errors`,  validateFormField(prop, model));
  }

  handleContactUpdate = (event, model, prop, value) => {

    const contactForm = get(merge({}, {...this.state}), 'contactForm');

    this.updateFormFields(contactForm[model], prop, value || event.target.value);

    const showErrors = this.hasErrors(contactForm);
    this.setState(merge({}, omit(this.state, ['contactForm']), {contactForm, showErrors}));
  }

  handleSubmitContactForm = () => {
    const { dispatch } = this.props;
    const contactForm = merge({}, this.state.contactForm);
    this.validateContactForm(contactForm);
    const showErrors = this.hasErrors(contactForm);
    const newContact = reduce(contactForm, (form, model, prop) =>
        set(form, prop, reduceToValues(model)), {});

    if (showErrors) {
      return this.setState(merge({}, {...this.state}, {contactForm, showErrors}));
    }
    if (!isEmpty(newContact.user) || !isEmpty(newContact.profile)) {
      newContact.user.id = get(this.props.contact, 'user.id');
      newContact.company.id = get(this.props.contact, 'company.id');
      newContact.profile.id = get(this.props.contact, 'profile.id');
      dispatch(contactApi.updateContact(newContact, (err, data) => {
        if (err) {
          return console.error(err);
        }

        dispatch(updateUser(merge({}, this.props.contact.user, data.contact.user)));
        dispatch(contactStore.updateProfile(merge({}, this.props.contact.profile, data.contact.profile)));

        this.props.dispatch(ui.showSnackBar());
        this.goToDashboard();
      }));
    }
    else {
      this.goToDashboard();
    }
  }

  handleSave = (event) => {
    this.handleSubmitContactForm(event);
  }

  handleCancel = () => {
    this.goToDashboard();
  }

  render() {

    return (
      <div className='client-contact-info'>
        <h1>Contact Information</h1>
        {
          this.state.showForm
          &&
          <ContactInfoForm
            contact={this.state.contactForm}
            stateList={this.props.staticData.stateList}
            phoneTypeList={this.props.staticData.contactPhoneTypes}
            timezoneList={this.props.staticData.timezoneList}
            contactTypes={this.props.staticData.contactTypes}
            updateContact={this.handleContactUpdate}
          />
        }
        <ul className='form-submission-container'>
          <li className='submission-button'>
            {this.state.showErrors && <div className='error-message'>Please fill out missing fields.</div>}
          </li>
          <li className='submission-button'>
            <Button
              className='button-secondary-large'
              label='Cancel'
              onClick={this.handleCancel}
              />
          </li>
          <li className='submission-button'>
            <Button
              className='button-main-large'
              label='Save'
              onClick={this.handleSave}
              />
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/ClientContactInfo/index.js